module.exports = __webpack_public_path__ + "img/equiload.85e17a6a.gif";